document.addEventListener('DOMContentLoaded', () => {
  const productGridContainer = document.querySelector(
    '.product-grid-container',
  );

  if (!productGridContainer) {
    return;
  }

  let loadMore = document.querySelector('.button.load-more');
  let currentPage = 1;

  const loadMoreProducts = (
    pages,
    baseURL,
    desktopCount,
    mobileCount,
    productGrid,
  ) => {
    currentPage++;

    const url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.set('page', currentPage);
    const fetchURL = `${baseURL}?${url.searchParams.toString()}`;

    if (currentPage <= pages) {
      fetch(fetchURL)
        .then(function (response) {
          if (response.ok) {
            return response.text();
          }
          throw new Error('Network response was not ok.');
        })
        .then(function (html) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newProducts = doc.querySelectorAll('.grid__item--product');
          const fragment = new DocumentFragment();

          newProducts.forEach((product) => {
            fragment.appendChild(product);
          });

          productGrid.appendChild(fragment);

          const currentCount = [...productGrid.children].filter(
            (li) => !li.classList.contains('grid__item--promo'),
          ).length;
          if (desktopCount) {
            desktopCount.innerText = currentCount;
          }
          if (mobileCount) {
            mobileCount.innerText = currentCount;
          }

          if (currentPage == pages) {
            loadMore.style.display = 'none';
          }
        })
        .catch(function (error) {
          console.error('There was a problem with the fetch operation:', error);
        });
    }
  };

  const initializeCollectionLoadMore = () => {
    const productGrid = document.querySelector('ul.product-grid');
    loadMore = document.querySelector('.button.load-more');

    if (!productGrid || !loadMore) {
      return;
    }

    currentPage = Number(productGrid.getAttribute('data-current-page'));
    const pages = Number(productGrid.getAttribute('data-pages'));
    const baseURL = productGrid.getAttribute('data-handle');
    const desktopCount = document.querySelector('#productDisplayDesktop span');
    const mobileCount = document.querySelector('#productDisplayMobile span');

    loadMore.addEventListener('click', () => {
      loadMoreProducts(pages, baseURL, desktopCount, mobileCount, productGrid);
    });
  };

  initializeCollectionLoadMore();

  const activeFacets = document.querySelector('.active-facets');
  const elementObserver = new MutationObserver(initializeCollectionLoadMore);

  // Configuration of the observer (which mutations to observe)
  const config = {
    childList: true, // Observes additions or removals of child nodes
    subtree: true, // Observes changes in descendants
    attributes: false, // Set to true to observe attribute changes
    characterData: false, // Set to true to observe changes to the text content
  };

  // Start observing the target node
  elementObserver.observe(activeFacets, config);
});
